import React from 'react';
import Box from '@mui/material/Box';
import { makeStyles } from '@mui/styles';
import Grid from '@mui/material/Grid';

const useStyles = makeStyles({
	footerWrapper: {
		height: '230px',
		position: 'relative',
		width: '100%',
		padding: '16px 32px',
		backgroundColor: '#dee2e6',
		color: '#000000',
		fontSize: '13px'
	},
	copyright: {
		fontSize: '14px',
		textAlign: "center",
		width: '100%',
		bottom: '8px'
	},
	link: {
		color: '#000000',
		margin: '0.6vh'
	}
});
const Footer = (props: any) => {
	const classes = useStyles()
	const path: string = props.location.pathname
	if(path.indexOf('admin') > -1) {
		return <></>
	}
	return (
		<Box  className={classes.footerWrapper}>
			<Box display="flex" flexDirection="row">
				<Grid container>
					<Grid item sm={6}>
						<Box fontSize="13px">
							<b>Address:</b><br />
							1-61/2/7, Rahmat Gulshan Colony,<br />
							P Janardhan Reddy Nagar, Gachibowli <br />
							Hyderabad, Telangana 500032,<br />
							India<br /><br />
							<b>Phone:</b> <span>+918686340975</span><br />
							<b>Email:</b> <a className={classes.link} style={{ textDecoration: 'none'}}
								href="mailTo:raman7gupta@gmail.com"
							>raman7gupta@gmail.com
							</a>
						</Box>
					</Grid>
					<Grid item sm={6}>
						<Box display="flex" flexDirection="column-reverse" fontSize="13px">
							<a href="/aboutus" className={classes.link}>About Us</a>
							<a href="/contactus" className={classes.link}>Contact Us</a>
							{/* <a href="/carriers" className={classes.link}>Carriers</a> */}
						</Box>
					</Grid>
				</Grid>
			</Box>
			<Box className={classes.copyright}>ePridim@2021</Box>
		</Box>
	)
}

export default Footer;
